import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: self-start;
  .error-message {
    color: #babfc7;
    a {
      color: unset;
      text-decoration: unset;
      :hover {
        text-decoration: underline;
      }
    }
  }
  button {
    text-transform: unset;
    gap: 10px;
  }
`;
